module.exports = __webpack_public_path__ + "fonts/Knockout.d040580f.otf";